import Landing from "@/pages/Landing";
export default function UKLanding() {
  return <Landing marketKey="uk" showVSL />;
}
